import { render, staticRenderFns } from "./SalesReturnPage.vue?vue&type=template&id=c6680c70&"
import script from "./SalesReturnPage.vue?vue&type=script&lang=js&"
export * from "./SalesReturnPage.vue?vue&type=script&lang=js&"
import style0 from "./SalesReturnPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports